import * as React from 'react';

import { EInputMode, TUseDefaultInputModeResult } from '../types';

export function useDefaultInputMode(): TUseDefaultInputModeResult {
  return React.useState<EInputMode>(EInputMode.Address);
}
